import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'lib/moment-timezone-custom'
import Popover from '@material-ui/core/Popover'
import { testEnv } from 'lib/env'

export default class DropdownCalendar extends Component {
  constructor (props) {
    super(props)
    this.state = { isOpen: false }
    this.anchor = null
    this.calendarMax = moment().add(3, 'month').toDate()
  }

  async componentDidMount () {
    const { default: InfiniteCalendar } = await import(
      /* webpackChunkName: "react-infinite-calendar" */ 'react-infinite-calendar'
    )

    this.InfiniteCalendar = InfiniteCalendar
    this.setState({ importsLoaded: true })
  }

  handleOpenButton (ev) {
    this.anchor = ev.currentTarget
    this.setState({ isOpen: true })
  }

  handleDateSelect (date) {
    // convert browser time zone
    if (date instanceof Date) {
      date = moment(date).add(date.getTimezoneOffset() * -1 - moment(date).utcOffset(), 'minutes')
    }

    this.setState({ isOpen: false })
    this.props.onChange(date)
  }

  render () {
    const { placeholder, value } = this.props
    const { importsLoaded, isOpen } = this.state
    const { InfiniteCalendar, anchor } = this

    return (
      <div className="dropdown_calendar">
        <button type="button" onClick={this.handleOpenButton.bind(this)}>
          {value ? value.format('MMMM D') : placeholder}
        </button>
        <Popover
          open={isOpen}
          anchorEl={anchor}
          onClose={() => this.setState({ isOpen: false })}
          transitionDuration={testEnv ? 0 : 'auto'}
          classes={{ paper: 'dropdown_calendar_inner' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          {importsLoaded && (
            <InfiniteCalendar
              className='calendar'
              width="100%"
              height={220}
              rowHeight={30}
              theme={DropdownCalendar.Styles.CalendarTheme}
              selected={value && value.toDate()}
              minDate={new Date()}
              min={new Date()}
              autoFocus={false}
              maxDate={this.calendarMax}
              max={this.calendarMax}
              onSelect={this.handleDateSelect.bind(this)}
              displayOptions={{ showTodayHelper: false }}
            />
          )}
        </Popover>
      </div>
    )
  }
}

DropdownCalendar.Styles = {
  CalendarTheme: {
    accentColor: '#FFFFFF',
    floatingNav: {
      background: '',
      chevron: '',
      color: ''
    },
    headerColor: '',
    selectionColor: '',
    textColor: {
      active: '',
      default: ''
    },
    todayColor: '',
    weekdayColor: ''
  }
}

DropdownCalendar.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}
